var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclesLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 603,
    viewBox: "0 0 159 603",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.287 378.925C104.798 289.927 23.3358 227.093 -65.6628 238.583C-154.661 250.072 -217.495 331.534 -206.005 420.533C-194.516 509.531 -113.054 572.365 -24.0552 560.875C64.9434 549.386 127.777 467.924 116.287 378.925Z",
    stroke: "url(#paint0_linear_733_50877)",
    strokeWidth: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.287 378.925C104.798 289.927 23.3358 227.093 -65.6628 238.583C-154.661 250.072 -217.495 331.534 -206.005 420.533C-194.516 509.531 -113.054 572.365 -24.0552 560.875C64.9434 549.386 127.777 467.924 116.287 378.925Z",
    stroke: "url(#paint1_linear_733_50877)",
    strokeWidth: 38
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-101.888 48.5266C-6.00044 63.2969 59.7581 153.003 44.9878 248.89C30.2175 344.778 -59.4884 410.537 -155.376 395.766C-251.264 380.996 -317.022 291.29 -302.252 195.402C-287.482 99.5149 -197.776 33.7563 -101.888 48.5266Z",
    stroke: "url(#paint2_linear_733_50877)",
    strokeWidth: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.888 48.5266C-6.00044 63.2969 59.7581 153.003 44.9878 248.89C30.2175 344.778 -59.4884 410.537 -155.376 395.766C-251.264 380.996 -317.022 291.29 -302.252 195.402C-287.482 99.5149 -197.776 33.7563 -101.888 48.5266Z",
    stroke: "url(#paint3_linear_733_50877)",
    strokeWidth: 38
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_733_50877",
    x1: -21.6225,
    y1: 579.719,
    x2: -68.0955,
    y2: 219.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_733_50877",
    x1: -21.6225,
    y1: 579.719,
    x2: -68.0955,
    y2: 219.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_733_50877",
    x1: -321.03,
    y1: 192.51,
    x2: 63.7664,
    y2: 251.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_733_50877",
    x1: -321.03,
    y1: 192.51,
    x2: 63.7664,
    y2: 251.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesLeft);
export default __webpack_public_path__ + "static/media/circles-left.741c8ec598478592095e9710cad3f9c3.svg";
export { ForwardRef as ReactComponent };